import axios from 'axios'
import {
  requestHandler,
  responseHandler,
  responseErrorHandler
} from 'services/Instances/utils'

import { ApiType, getAxiosConfiguration, errorHandler } from './configuration'

const axiosConfiguration = getAxiosConfiguration(ApiType.Gst)
const gstApiClient = axios.create(axiosConfiguration)

gstApiClient.interceptors.request.use(requestHandler, errorHandler)
gstApiClient.interceptors.response.use(responseHandler, responseErrorHandler)

export { gstApiClient }
